import React, { useEffect, useState } from 'react';
import { SERVICE_CONFIG, ServiceConfigData } from 'constants/service-config';

function useServiceConfig() {
    const [serviceConfig, setServiceConfig] = useState<ServiceConfigData & { readyConfig: boolean }>({
        readyConfig: false,
        name: '' as 'fulfillment',
        serviceOrigin: null,
        servicePath: null,
        redirectServicePath: null,
        paymentType: null,
        communicationType: null,
        defaultVoucherCode: '',
        defaultPharmcareProgram: null,
    });

    useEffect(() => {
        const getServiceConfigWithPathname = () => {
            const pathname = window.location.pathname;
            const isClaimService = Object.values(SERVICE_CONFIG).some((s) => s.servicePath && pathname.startsWith(s.servicePath));

            if (!isClaimService) {
                setServiceConfig({
                    readyConfig: true,
                    name: '',
                    serviceOrigin: '',
                    servicePath: '',
                    redirectServicePath: '',
                    paymentType: '',
                    communicationType: '',
                    defaultVoucherCode: '',
                    defaultPharmcareProgram: '',
                } as any);
                return; //end
            }

            const indexOfSlash2 = pathname.indexOf('/', 2);
            const pathnameAfterServicePath = pathname.substring(indexOfSlash2, pathname.length);
            let _servicePath = pathname.substring(0, indexOfSlash2);

            if (['/fulfillment', '/consult'].some((s) => pathnameAfterServicePath.startsWith(s))) {
                const indexOfSlash3 = pathname.indexOf('/', indexOfSlash2 + 1);
                _servicePath = pathname.substring(0, indexOfSlash3);
            }
            const findServiceConfig = Object.values(SERVICE_CONFIG).find((f) => f.servicePath === _servicePath);

            if (findServiceConfig) {
                setServiceConfig((prev) => ({
                    ...prev,
                    readyConfig: true,
                    name: findServiceConfig.name,
                    serviceOrigin: findServiceConfig.serviceOrigin,
                    servicePath: findServiceConfig.servicePath,
                    redirectServicePath: findServiceConfig.redirectServicePath,
                    paymentType: findServiceConfig.paymentType,
                    communicationType: findServiceConfig.communicationType,
                    defaultVoucherCode: findServiceConfig.defaultVoucherCode,
                    defaultPharmcareProgram: findServiceConfig.defaultPharmcareProgram,
                }));
            }
        };
        getServiceConfigWithPathname();
    }, [window.location.pathname]);

    return serviceConfig;
}

export default useServiceConfig;
